import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary, #FFF9F2)' }}>
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--text-secondary, #555)', fontSize: 14, marginBottom: 32
          }}
          data-testid="privacy-back-btn"
        >
          <ArrowLeft size={16} /> Terug naar Home
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <Shield size={28} style={{ color: 'var(--accent-primary, #6366f1)' }} />
          <h1 style={{ fontSize: 32, fontWeight: 600, color: 'var(--text-primary, #232323)', margin: 0 }}>
            Privacybeleid
          </h1>
        </div>

        <p style={{ color: 'var(--text-secondary, #555)', marginBottom: 8, fontSize: 14 }}>
          Laatst bijgewerkt: februari 2026
        </p>

        <div style={{ background: '#0E1620', borderRadius: 16, padding: '40px 36px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', lineHeight: 1.7, color: '#F4F7FB', fontSize: 15 }}>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB', marginTop: 0 }}>1. Inleiding</h2>
          <p>Krypton9 ("wij", "ons", "onze") respecteert uw privacy en is toegewijd aan het beschermen van uw persoonsgegevens. Dit Privacybeleid beschrijft hoe wij informatie verzamelen, gebruiken en beschermen wanneer u onze diensten gebruikt.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>2. Welke gegevens verzamelen wij</h2>
          <p>Wij kunnen de volgende gegevens verzamelen:</p>
          <ul>
            <li>Naam, e-mailadres, telefoonnummer en bedrijfsnaam bij het invullen van contactformulieren</li>
            <li>Accountgegevens bij registratie op ons platform</li>
            <li>Gebruiksdata en interactiegegevens binnen het platform</li>
            <li>Technische gegevens zoals IP-adres en browsertype</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>3. Hoe gebruiken wij uw gegevens</h2>
          <p>Wij gebruiken uw gegevens om:</p>
          <ul>
            <li>Onze diensten te leveren en te verbeteren</li>
            <li>Met u te communiceren over uw verzoeken en onze diensten</li>
            <li>Wettelijke verplichtingen na te komen</li>
            <li>Onze nieuwsbrief te verzenden (alleen met uw toestemming)</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>4. Gegevensbescherming</h2>
          <p>Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen ongeoorloofde toegang, verlies of misbruik.</p>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>5. Uw rechten</h2>
          <p>Op grond van de AVG heeft u het recht om:</p>
          <ul>
            <li>Inzage te vragen in uw persoonsgegevens</li>
            <li>Rectificatie of verwijdering te verzoeken</li>
            <li>Bezwaar te maken tegen verwerking</li>
            <li>Uw gegevens over te dragen (dataportabiliteit)</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#F4F7FB' }}>6. Contact</h2>
          <p>Voor vragen over dit privacybeleid kunt u contact opnemen via:</p>
          <p style={{ fontWeight: 500 }}>E-mail: info@krypton9.com</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
